"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = void 0;
var _Icon = require("./Icon");
// TODO: in v9, move styled() from Icon.jsx to here
var StyledIcon = _Icon.Icon;
exports.StyledIcon = StyledIcon;